import React, { useCallback } from 'react';
import { Flexer, Checkbox } from '@ontruck/orc';

import VehicleImage from 'components/VehicleImage';

const JourneyMapFilter = ({ onToggleValue, vehicleTypeValues }) => {
  const toggleCheckbox = useCallback(
    (e, { name, value }) => {
      onToggleValue(name, value);
    },
    [onToggleValue]
  );

  const vehicleTypes = ['van', 'box_van', 'rigid_truck', 'semi_trailer', 'trailer'];
  const vehicleTypeCheckboxes = vehicleTypes.map((vType) => (
    <Checkbox
      contracted
      girded
      name={vType}
      label={<VehicleImage type={vType} />}
      checked={vehicleTypeValues.includes(vType)}
      onChange={toggleCheckbox}
    />
  ));
  return (
    <Flexer.Parent p="XS" alignItems="center" justifyContent="flex-end">
      <Flexer.Child>{vehicleTypeCheckboxes}</Flexer.Child>
    </Flexer.Parent>
  );
};

export default JourneyMapFilter;
